import { Modal, Space, Select, Button } from 'antd'
import styles from './SortModal.module.scss'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const SortModal = ({ open, columns, sorter, onApply, onClose, sortOptions }) => {
  const { t: translation } = useTranslation();
  const [localSorter, setLocalSorter] = useState(sorter)
  const finalSortOptions = sortOptions || columns.map((col) => ({
    label: col.title,
    value: col.dataIndex || col.key,
  }))
  return (
    <Modal title={translation("dataTable.sort")} open={open} onCancel={onClose} footer={null} width={350} centered className={styles.sortModal}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Select
          placeholder={translation("dataTable.select_column")}
          style={{ width: '100%' }}
          value={localSorter.key}
          allowClear
          onChange={(key) => setLocalSorter((s) => ({ ...s, key }))}
          options={finalSortOptions}
          size="large"
        />
        <Select
          placeholder={translation("dataTable.select_order")}
          style={{ width: '100%' }}
          value={localSorter.value}
          allowClear
          onChange={(value) => setLocalSorter((s) => ({ ...s, value }))}
          options={[
            { label: translation("dataTable.asc"), value: 'asc' },
            { label: translation("dataTable.desc"), value: 'desc' }
          ]}
          size="large"
        />
        <Button
          type="primary"
          style={{ marginTop: 8 }}
          block
          size="large"
          onClick={() => onApply(localSorter)}
          disabled={!localSorter.key || !localSorter.value}>
          {translation("dataTable.apply")}
        </Button>
      </Space>
    </Modal>
  )
}

export default SortModal
